import $ from 'jquery';
import axios from 'axios';

const isRoute = window.location.href.indexOf('/stripe') !== -1;

const url = '/rest/stripe/info/public-key';

const fetchClientSecret = () => $('#checkout').data('token');

const mountStripeCheckout = async () => {
    try {
        const response = await axios.get(url);
        const stripe = await Stripe(response.data.publicKey);
        const checkout = await stripe.initEmbeddedCheckout({ fetchClientSecret });

        checkout.mount('#checkout');
    } catch (error) {
        console.log(error);
    }
};

export const stripeHandlers = () => {
    if (!isRoute) {
        return;
    }

    mountStripeCheckout()
        .catch(error => {
            console.log(error);
        });
};
